<template>
  <v-content class="maindash">
      <v-layout align-center justify-center class="mt-10">
          <v-row class="mt-10">
         <v-col>
        <div v-if="veterinarys.length == 0">
            <div>
                <p>No hay veterinarias disponibles</p>
            </div>
        </div>
          <v-card
          v-else
            class="mx-auto mb-5  mt-5 text-center"
            max-width="344"
            v-for="vendor in veterinarys"
            :key="vendor.vendorId"
          >
            <v-col cols="12">
              <v-row justify="center">
                <v-card-title>{{ vendor.storeName }}</v-card-title>
              <v-avatar size="62">
                <v-img
                  :src="giveUrl(vendor.image)"
                ></v-img>
              </v-avatar>
              </v-row>
              
            </v-col>
            <v-card-text class="text-left">
              <div> <p>Dirección: {{vendor.addrress}}</p> </div>
             <div> <p>Tel:{{vendor.phoneNumber}}</p> </div>
            </v-card-text>
          </v-card>
        </v-col>
        </v-row>
        
      </v-layout>
  </v-content>
</template>

<script>
import { mapActions } from "vuex";
export default {
    created() {
    this.getStoresMet();
  },
  data() {
    return {
        veterinarys:[],
  }
  },
methods:{
    ...mapActions("admin", {
      getStores: "getStores"
    }),
    getStoresMet() {
      this.getStores().then((res) => {
          console.log(res)
        this.veterinarys = res;
      });
    },
    giveUrl(ur){
        var urlcool = "http://localhost:8000"+ur; 
        return urlcool
    },
}
}
</script>

  
<style>
.maindash {
  background-image: url("../assets/img/backgrounds/fondoblanco.png");
  background-size: cover;
}
</style>